import { Component, OnInit } from '@angular/core';
import {EventsService} from '../../../../globalservices/events/events.service';
import {SpeakerService} from '../../../../globalservices/speaker/speaker.service';
import { SessionHelper } from '../../../shared/services/localstorage';
import{LoginService} from './../../../../globalservices/login.service';

@Component({ 
  selector: 'app-speakerdashboard',
  templateUrl: './speakerdashboard.component.html',
  styleUrls: ['./speakerdashboard.component.scss']
})
export class SpeakerdashboardComponent implements OnInit {

  constructor(private loginService:LoginService,private speakerService:SpeakerService,private eventsService:EventsService) { }
  cardTraining: any = {
    api_done : false,
    data : []
  };
  ngOnInit() {
    if(SessionHelper.isLoggedIn){
      this.loginService.changeStatus(true);
      this.loginService.changePageTitle('Dashboard');
     }else{
      this.loginService.changeStatus(false);
      this.loginService.changePageTitle('');
     }
  
  }
}
